import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 18 18" focusable="false" aria-hidden="true"><defs><clipPath id="content-management__a"><rect width={18} height={18} rx={0} /></clipPath></defs><g clipPath="url(#content-management__a)"><path d="M16.61 16.382q.504-.584.516-1.436V10.11q0-.33-.237-.575-.242-.25-.573-.25h-.666V5.342q0-.875-.62-1.495-.62-.62-1.496-.62h-.658v-.22q0-.875-.62-1.495-.62-.62-1.496-.62H4.39q-.876 0-1.496.62t-.62 1.495v6.277h-.586q-.33 0-.565.236-.234.234-.234.565L.874 14.58q0 1.117.509 1.775.568.734 1.634.734l11.607.016q1.317.054 1.986-.723ZM3.846 9.284h7.458V3.007q0-.224-.16-.384t-.384-.16H4.39q-.226 0-.385.16-.16.16-.16.384v6.277Zm9.03-4.485v4.485h1.202V5.342q0-.224-.16-.384t-.384-.16h-.658Zm2.68 6.066V14.551q.002.584-.099.753-.147.248-.732.23h-.004l-11.67-.017h-.004q-.302.009-.462-.216-.143-.2-.128-.437v-.008l.001-3.988 13.098-.003Zm-3.247 2.848q.234-.235.234-.565 0-.33-.234-.566-.234-.235-.564-.235H6.259q-.33 0-.564.235-.235.235-.235.566 0 .33.234.565.235.235.565.235h5.486q.33 0 .564-.235Z" fillRule="evenodd" fill="#000" /></g></svg>

const ContentManagement = React.forwardRef((props, ref) => {
  return (
    <IconBase name="content-management" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

ContentManagement.displayName = 'IconContentManagement'

export default ContentManagement
